import { createStore } from 'vuex'
import { fs_getUserInfo } from '@/utils/app'
import helps from './modules/help'
import ua from '@/utils/platform'
import { getWxUserInfo, wechatAuthCode } from '@/utils/wx'
import { getQueryString } from '@/utils/url'
import request from '@/api'

export default createStore({
  state() {
    return {
      token: '',
      isApp: false,
      isWeixin: false,
      post: {}, // 帖子
      pageCid: 0, // 渠道号
      pageInfo: 0, // 用于跳转
      commentOrder: 'hotCount', // 评论排序
      listOrder: '', // 社区排序
      helpOrder: '', // 帮办排序
      member: {}
    }
  },
  getters: {
    getToken: (state) => {
      return state.token.length > 0 ? state.token : localStorage.getItem('fs_token')
    }
  },
  mutations: {
    setToken(state, token) {
      console.log('setToken', token)
      localStorage.setItem('fs_token', token)
      state.token = token
      if (token) {
        request.getMemberByToken().then((res) => {
          state.member = res
          localStorage.setItem('_user_id', res.memberId)
          // eslint-disable-next-line no-undef
          qaplus.event.setMetaInfo(localStorage.getItem('_user_id'))
          // eslint-disable-next-line no-undef
          pocplus.event.config('user_unique_id', localStorage.getItem('_user_id'))
        })
        localStorage.setItem('isReLogin', 0)
      }
    },
    setPageInfo(state, pageInfo) {
      state.pageInfo = pageInfo
    }
  },
  actions: {
    _initApp({ state, commit }) {
      // 初始化app浏览器状态
      state.isWeixin = ua.isWeixin
      const token = localStorage.getItem('fs_token')
      console.log('fdsaf>>>>>>>>>>', token)

      if (token && token.length > 0) {
        // 初始化token
        commit('setToken', token)
      } else {
        if (state.isWeixin) {
          // 微信 同时需要强制授权
          let query = getQueryString()
          if (query && query.code && query.code.length > 0) {
            // 获取微信个人信息
            getWxUserInfo(query.code).then((token) => {
              // 设置token
              commit('setToken', token)
            })
          } else {
            // 微信授权
            wechatAuthCode()
          }
        }
      }
      return fs_getUserInfo()
    }
  },
  modules: {
    helps
  }
})
